import React, { useContext } from "react";
import { css } from "@emotion/react";
import { PublishedContext } from "../context/published-state";
import { colors } from "../assets/styles/variables";
import Recommended from "./recommended";

const statusSlide = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  max-width: 342px;
  margin: 0 auto;

  .statusText {
    padding: 10px 0;
    font-size: 22px;
    color: ${colors.white};
    text-align: center;
  }
`;

interface Props {
  slug: string;
}

const StatusSlide = (props: Props) => {
  const { slug } = props;
  const publishedState = useContext(PublishedContext)[0];

  return (
    <div css={statusSlide}>
      {publishedState.init && <p className="statusText">読み込み中……</p>}
      {!publishedState.init &&
        <>
          {publishedState.soon && <p className="statusText">この作品は未公開です</p>}
          {publishedState.late && <p className="statusText">公開期間が終了しました</p>}
          <Recommended ownSlug={slug} isIncludedOwnSlug={true} />
        </>
      }
    </div>
  );
};

export default StatusSlide;
